// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__1Cihc","container":"styles_container__1IDy5","title":"styles_title__1Ku6j","wrapper":"styles_wrapper__1oZFt","answer":"styles_answer__1-Pmd"};